// Product ID to single Variant ID mapping
let tangent_selected_product_map;

const default_addToCartText = "ADD TO CART";
const default_addedToCartText = "Added to Cart!";
const default_add_all_to_cart_text = "Add All to Cart"
const out_of_stock_text = "Out of Stock";
const no_products_found_text ="No products found. Please retry!";

let tangent_client_url;
let tangent_recommended_products;

let tangent_client_domain_currency;

// Map variable to store add all to cart links for each sections
let sections_add_to_cart_map={};

// Add default image url here
const tangent_default_selfie_image_url="";
const default_variant_image_url ="https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp"

const tangent_client_domain_url = window.location.origin;
const tangent_sections_wrapper_element = document.querySelector("#tangent_sections_wrapper"); 

function onLoadFunction(){
  var tangent_response_id = getClientResponseId()
  checkoutDataApiCall(tangent_response_id);
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", (event) => {
        onLoadFunction();
    });
} else {
    onLoadFunction();
}


function getClientResponseId(){
  // Current Page Load URL
  tangent_client_url = new URL(window.location.href);
  return tangent_client_url.searchParams.get("resp_id");
}

function checkoutDataApiCall(tangent_response_id){
  if (tangent_response_id != null) {
    const checkout_url = "https://service.tangent.ai/shopify/get-checkout-products?resp_id="+tangent_response_id+ "&self_serve=true" + "&multiple_variants=true";
    fetch(checkout_url)
    .then(data => {
      return data.json();
    })
    .then(response => {
      checkoutDataProcess(response);
      return response;
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
}

function checkoutDataProcess(response){
    setElementDisplayById("loading-section","none");
    tangent_recommended_products = response.products;

    tangent_client_domain_currency = document.querySelector("#tangent_client_currency").innerText; 

    // Setting Default variant price symbol
    if (tangent_client_domain_currency == "") {
        tangent_client_domain_currency = '$';
    }

    // Setting selfie / default image
    // setTangentSelfieSection(response);
  
    const tangent_product_sections = response.product_sections;
    const tangent_text_sections = response.text_sections;
    
    if(tangent_product_sections!=undefined){
      createProductSection(tangent_product_sections, tangent_text_sections);
    }    

    if(response.text_sections!=undefined){
      createTextSection(tangent_product_sections,tangent_text_sections);
    }

    if (tangent_recommended_products.length > 0) {
        setProductsToView(tangent_recommended_products, tangent_product_sections, response.selected_variants);
        enableButtonListener();
        loadElementsOnResponseData();   
    }
}

const setElementDisplayById = (elementId, displayStyle) => {
  const element = document.getElementById(elementId);
  if (element) {
      element.style.display = displayStyle;
  }

}

function setProductsToView(products, sections, selected_variants) {
  tangent_selected_product_map = {};
  Object.keys(sections).forEach(section => {
    const product_ids = sections[section];
    const product_section_grid = document.getElementById(section + "_product_grid");

    // Create a document fragment for improved performance
    const fragment = document.createDocumentFragment();
    
    for (const id of product_ids) {
      for (let p = 0; p < products.length; p++) {
        // Find product by ID
        if (String(products[p].id) === id) {
          const product = products[p];
          const variant = getSelectedVariant(product, selected_variants[product.id]);
          const variantId = variant.id.split("/").pop();
          // Track selected product variant
          tangent_selected_product_map[product.id] = variantId;
          // Generate product HTML and append it to the fragment
          const product_html = getProductHTML(product, p, variant, section, sections, variantId);
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = product_html;
          
          // Append the created product HTML to the fragment
          while (tempDiv.firstChild) {
            fragment.appendChild(tempDiv.firstChild);
          }
        }
      }
    }
    if(section=="section_cream_foundation"){
        const selfie_container = document.getElementById("tangent_section_selfie_parent_wrapper");
        selfie_container.appendChild(fragment);
    }
    else{
        // Append the fragment to the DOM in one go
        product_section_grid.appendChild(fragment);
    }
    
  });
}

function getSelectedVariant(product, variant_list) {
  const productVariants = product.variants || [];
  if (productVariants.edges.length === 0) {
    throw new Error("No variants available for the product.");
  }
  if (variant_list.length > 0) {
    const selectedVariantId = Number(variant_list[0]);

    const matchedVariant = productVariants.edges.find(edge =>
      extractShopifyNumericId(edge.node.id) === selectedVariantId
    );

    return matchedVariant?.node || productVariants.edges[0].node;
  }
  return productVariants.edges[0].node;
}

function extractShopifyNumericId(gid) {
  if (typeof gid !== 'string') return null;

  const match = gid.match(/\d+$/);
  return match ? Number(match[0]) : null;
}

function getProductHTML(product, index, variant, section, sections, variantId) {
    
  // Setting default / first variant data
  const variant_image_url = getVariantImage(variant, product);
  const variant_product_url = `${tangent_client_url.origin}/products/${product.handle}?variant=${variantId}`;
  let buttonClass="";
  let addbuttontext = default_addToCartText;
  if(isProductAvailable(product, variant)){
    updateSectionAllToCartLink(sections, product.id, tangent_selected_product_map[product.id], section);
  }
  else{
    addbuttontext = out_of_stock_text;
    buttonClass ="disable-button";
  }

  // Default Text Under Shade
  let defaultText ="";
  if(section=="section_cream_foundation"){
    defaultText =`<p class="selfie-default-text">Experience the raw power of nature while enjoying a weightless, light-to-medium skin filter.
A dewy finish heightens natural glow as pure ingredients nourish deeply.
Post-biotics, skin superfoods, and a rich blend of certified organic oils melt into the skin, instantly transforming its appearance and creating healthier-looking skin over time.</p>`;
  }

  const variantTitle = variant.title.toLowerCase() != "default title" 
  ? `<p class="tangent-variant-title">${variant.title}</p>` 
  : "";


  // Product View HTML using template literals
  const product_html = `
      <div class="product_view">
        <a id="url_tangent_product_${index}" class="tangent-text-link dfgdgdgdgdf" target="_blank" href="${variant_product_url}">
          <img id="image_tangent_product_${index}" src="${variant_image_url}" class="tangent_product_image" alt="${product.title}">
          <p class="tangent-product-title tangent_product_title_text">${product.title}</p>
          ${variantTitle}
        </a>
        ${defaultText}
        <div id="${section}_variant_${index}"></div>
        <button class="tangent-product-add-btn-wrapper product-item tangent-btn-add tangent_add_to_cart_button btn ${buttonClass}" id="${variantId}" data-variantId="${variantId}">
            ${addbuttontext}
        </button>
      </div>
  `;
  return product_html;
}



const getPriceHTML = (price) =>{
  return `
  <p class="price-item--regular tangent-regular-price-on-sale price tangent-product-price-text tangent-original-price price">
    <span class='notranslate' htmoney=""><strong>${tangent_client_domain_currency} ${price}</strong></span>
  </p>`;
}

function isProductAvailable(product, variant){
  // Check if the product is active
  if (product.status.toLowerCase() !== "active") {
      return false;
  }
  return variant.availableForSale;
}

// Updating add all to cart object for sections
function updateSectionAllToCartLink(product_sections, product_id, vid) {
    if (!product_sections) return;
    
    for (const section in product_sections) {
        if (product_sections[section].includes(String(product_id))) {
            // Initialize section if it doesn't exist
            if (!sections_add_to_cart_map[section]) {
                sections_add_to_cart_map[section] = {
                    count: 0,
                    cart_link: tangent_client_domain_url + "/cart/add?",
                    list: []
                };
            }

            // Update section if vid is not already included
            const sectionData = sections_add_to_cart_map[section];
            if (!sectionData.list.includes(vid)) {
                sectionData.count++;
                sectionData.cart_link += `&id[]=${vid}`;
                sectionData.list.push(vid);

                // Show "Add All to Cart" button if more than one product
                const addAllButton = document.getElementById(`${section}`);
                if (addAllButton) {
                    addAllButton.style.display = sectionData.count > 1 ? "block" : "none";
                }
            }
        }
    }
}


function createFormDataFromIds(idArray) {
  return {
    items: idArray.map(id => ({
      id: id,
      quantity: 1
    }))
  };
}

function addToCart(element){ 
  const formData = createFormDataFromIds([element.id]);
  addToCartApi(formData, element);
}

// Add all to cart function for sections
function addAllTocartFunction(element) {
  
  const formData = createFormDataFromIds(sections_add_to_cart_map[element.id].list);
  if(formData){
    addToCartApi(formData, element);
  } 
  else {
      var x = document.querySelector("#message-text");
      x.innerHTML = "We're currently sold out of the selected product(s). Please check back later!";
      x.className = "show";
      setTimeout(function () { x.className = x.className.replace("show", ""); }, 5000);
  }
}

function addToCartApi(payload, element){
  element.innerHTML = `<div class="loader button-loader">&nbsp;</div>`
  fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
  }).then(() => {
    element.innerHTML = default_addedToCartText;
    element.classList.add("added-to-cart-style"); 
  }).catch((error) => {
      console.error('Error:', error);
  });
}

const getProductData = (sectionName) => {
  const sectionVariantList= sections_add_to_cart_map[sectionName].list;
  const allVariantList = Object.values(tangent_selected_product_map);
  let productData = {
   'items': []
  };
  for (let variantId of sectionVariantList) {
    let item = {
      'id': variantId,
      'quantity': 1,
      'properties': {
        '_type': 'tangent-quiz'
      }
    }
    productData.items.push(item);
  }
  return productData;
}

const getVariantImage = (variant, product) => {
  const fallbackImage = 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';
  if (variant?.image?.url) {
    return variant.image.url;
  }
  if(product?.images?.nodes.length > 0){
    return product?.images?.nodes[0].url
  }
  return fallbackImage;
};

// Add To Cart Function
function addToCartFunction(cartButton){ 
  let variantId = Number(cartButton.getAttribute("data-variantId"));
  if(cartButton){

    // const sections = miniCart ? miniCart.getSectionsToRender().map((section) => section.id) : [];
    
    let formData = {
     'items': [{
      'id': variantId,
      'quantity': 1,
      'properties': {
        '_type': 'tangent-quiz'
      }
      }],
      'sections': sections,
      'sections_url': window.location.pathname
    };
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      cartButton.innerHTML = default_addedToCartText;
      cartButton.classList.add("added-to-cart-style"); 
      document.dispatchEvent(new CustomEvent('cart:build' , {bubbles: true})); 
      document.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
      }));
      return response.json();
    }).then((parsedState) => {
     
    }).catch((error) => {
      console.error('Error:', error);
    });
  }
}

// Main Section container 
function createSectionContainer(section_name){
    var section_container = document.createElement("div");
    section_container.id=section_name+"_container";
    return section_container;
}

// Add to cart button for sections
function createSectionAddAllToCart(section_name) {
    const buttonContainer = document.createElement("div");
    buttonContainer.classList.add(`${section_name}_button_container`);
    var add_all_to_cart_button = document.createElement("button");
    add_all_to_cart_button.id = section_name;
    add_all_to_cart_button.classList.add("section_add_all_to_cart");
    add_all_to_cart_button.classList.add(section_name+"_add_all_to_cart");

    add_all_to_cart_button.classList.add("section_add_all_cart_link");
    add_all_to_cart_button.classList.add(section_name+"_add_all_cart_link");
    add_all_to_cart_button.setAttribute('data-sectionName', section_name);
    add_all_to_cart_button.innerHTML = default_add_all_to_cart_text;
    buttonContainer.appendChild(add_all_to_cart_button);
    
    // Enabling listener
    add_all_to_cart_button.addEventListener(
        'click',
        function () { addAllTocartFunction(this); },
        false
    );
    return buttonContainer;
    
}

// Container having individual products
function addSectionProductGridContainer(section_name) {
    var product_grid_view_container = document.createElement("div");
    product_grid_view_container.id = section_name+"_product_grid";
    product_grid_view_container.classList.add("section_product_grid");
    product_grid_view_container.classList.add(section_name+"_product_grid");
    return product_grid_view_container;
}

// Product Section Creation
function createProductSection(product_sections = {}, text_sections = {}) {
  if (!product_sections || Object.keys(product_sections).length === 0) return;

  for (const section_name in product_sections) {
    const section_container = createSectionContainer(section_name);
    
    // Create text section if exists
    if (text_sections?.[section_name]) {
      createTextSectionBeforeProducts(text_sections, section_container, section_name);
    }

    // Product grid
    section_container.appendChild(addSectionProductGridContainer(section_name));

    // Add all to cart button for routine sections
    // section_container.appendChild(createSectionAddAllToCart(section_name));
    
    // Append section to correct parent
    tangent_sections_wrapper_element.appendChild(section_container);
    
  }
}


// Text Sections with products sections
function createTextSectionBeforeProducts(text_sections,section_container, section_name){
    if(text_sections[section_name]!=undefined){
        var section_div = document.createElement("div");
        section_div.id = section_name+"_text_container";
        section_div.classList.add("section_text_container");
        section_div.classList.add(section_name+"_text_container");
        section_div.innerHTML = text_sections[section_name].join(' ');
        section_container.appendChild(section_div);
    }
}

// Section Text Creation (one without a product section)
function createTextSection(product_sections, text_sections){
    for (const section_name in text_sections) {
        // For removing duplicate entry
        if(product_sections[section_name]!=undefined || section_name == "section_selfie"){
            var section_container = createSectionContainer(section_name);

            var section_div = document.createElement("div");
            section_div.id = section_name+"_text_container";
            section_div.classList.add("section_text_container");
            section_div.classList.add(section_name+"_text_container");
            section_div.innerHTML = text_sections[section_name].join(' ');
            section_container.appendChild(section_div);  

            // To Add to top of the page container
            if(section_name == "section_selfie"){
              var section_selfie = document.querySelector("#section_selfie_container_parent");
              section_selfie.appendChild(section_container);
            }
            else{
              // Add to main container wrapper
              // tangent_sections_wrapper_element.appendChild(section_container); 
            }   
        }
    }
}

// Setting Selfie / Default Image
function setTangentSelfieSection(response) {
  hideLoading();

  const selfieContainer = document.getElementById("tangent_selfie_image_container");
  const selfieImage = document.querySelector("#tangent_selfie_image");
  const containerWrapper = document.querySelector("#tangent_selfie_container");

  if (response?.selfie_html) {
    selfieContainer.innerHTML = response.selfie_html;
    return;
  }

  if (response?.selfie_url) {
    selfieImage.src = response.selfie_url;
    selfieImage.classList.remove("default-selfie-image");
    return;
  }

  if (typeof tangent_default_selfie_image_url === "string" && tangent_default_selfie_image_url.trim() !== "") {
    selfieImage.src = tangent_default_selfie_image_url;
    selfieImage.classList.add("default-selfie-image");
  } else {
    containerWrapper.style.display = "none";
  }
}

// Enabling button listeners
function enableButtonListener(){
    // Listner for section add all to carts
    var add_all_cart_buttons = document.querySelectorAll('.tangent-product-add-btn-wrapper');
    for (var b = 0; b < add_all_cart_buttons.length; b++) {
        add_all_cart_buttons[b].addEventListener(
            'click',
            function () { addToCart(this); },
            false
        );
    }
}

function loadElementsOnResponseData(){
  var all_elements = document.querySelectorAll('.load-on-data');
  for (var ae = 0; ae < all_elements.length; ae++) {
      all_elements[ae].style.display="flex";
  }
}

// Hide loading
function hideLoading(){
  document.querySelector("#loading-section").style.display = "none";
}

function setElementDisplay(elementId, display){
  document.querySelector("#"+elementId).style.display = display;
}